import { render, staticRenderFns } from "./centerTransfer.vue?vue&type=template&id=76e8cb91&scoped=true&"
import script from "./centerTransfer.vue?vue&type=script&lang=js&"
export * from "./centerTransfer.vue?vue&type=script&lang=js&"
import style0 from "./centerTransfer.vue?vue&type=style&index=0&id=76e8cb91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8cb91",
  null
  
)

export default component.exports